/**
 * Terms — placeholder shell pending legal copy.
 *
 * Per Part 3 spec: friendly placeholder until the legal team finalizes
 * actual terms. The page exists so the footer link doesn't dead-end.
 */
import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PublicPageShell from "@/components/PublicPageShell";

export default function Terms() {
  return (
    <PublicPageShell mainClass="flex items-center justify-center px-6 py-20">
      <section
        className="pp-wrap text-center max-w-2xl"
        data-testid="terms-page"
      >
        <span className="pp-eyebrow" data-testid="terms-eyebrow">
          <span className="dot" />
          Legal
        </span>
        <h1 className="pp-h1 mt-6" data-testid="terms-headline">
          Terms of Service
        </h1>
        <p
          className="pp-sub mt-5 mx-auto max-w-xl"
          data-testid="terms-subtitle"
        >
          Coming soon. Our legal team is finalizing the language now.
        </p>
        <p
          className="pp-customer-p mt-6 mx-auto max-w-xl text-left"
          data-testid="terms-body"
        >
          Real, plain-English terms will land here before we open public
          access. Want to flag a concern, ask a question, or get
          notified when the policy ships?{" "}
          <Link
            to="/contact"
            className="font-semibold text-pp-orange hover:underline"
            data-testid="terms-contact-link"
          >
            Reach out anytime
          </Link>
          .
        </p>
        <div className="mt-10 flex items-center justify-center">
          <Link
            to="/"
            className="pp-btn pp-btn-ghost"
            data-testid="terms-back-cta"
          >
            <ArrowLeft className="h-4 w-4" aria-hidden="true" />
            Back to home
          </Link>
        </div>
      </section>
    </PublicPageShell>
  );
}
